var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4C8.08172 4 4.5 7.58172 4.5 12C4.5 16.4183 8.08172 20 12.5 20C16.9183 20 20.5 16.4183 20.5 12C20.5 7.58172 16.9183 4 12.5 4ZM2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12ZM8.29289 7.79289C8.68342 7.40237 9.31658 7.40237 9.70711 7.79289L12.5 10.5858L15.2929 7.79289C15.6834 7.40237 16.3166 7.40237 16.7071 7.79289C17.0976 8.18342 17.0976 8.81658 16.7071 9.20711L13.9142 12L16.7071 14.7929C17.0976 15.1834 17.0976 15.8166 16.7071 16.2071C16.3166 16.5976 15.6834 16.5976 15.2929 16.2071L12.5 13.4142L9.70711 16.2071C9.31658 16.5976 8.68342 16.5976 8.29289 16.2071C7.90237 15.8166 7.90237 15.1834 8.29289 14.7929L11.0858 12L8.29289 9.20711C7.90237 8.81658 7.90237 8.18342 8.29289 7.79289Z",
    fill: "#CD1812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleError);
export default __webpack_public_path__ + "static/media/icon_circle-error.5f78dbd02908aaecb978a60365210892.svg";
export { ForwardRef as ReactComponent };